module.exports = __webpack_public_path__ + "img/4355ab769abfd9d196d5f45ad31b68a5.png";